import { css } from "@emotion/react";
import { useLocation } from "react-router-dom";

import theme from "theme/index";
import LinkTo from "core/Components/LinkTo";
import { getURLSegmentsString } from "core/includes/formatters";
import RelatedEventPage from "pages/Components/OnlineEvent/components/RelatedEventPage";

type Props = {
    relatedEvents?: EventPage[]
}

const RelatedEvents = ({ relatedEvents = [] }: Props) => {
    const location = useLocation();
    const urlSegments = getURLSegmentsString(location.pathname);

    const style = css`
        margin-bottom: 40px;
    `;

    const relatedTitleStyle = css`
        font-size: 28px;
        color: ${theme.colours.curiousBlue2};
        margin-bottom: 20px;

        ${theme.breakpoints.only('md')} {
            padding-left: 125px;
        }
    `;

    const cardsContainerStyle = css`
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 52px;

        ${theme.breakpoints.only('xxl')} {
            column-gap: 30px;
        }

        ${theme.breakpoints.only('lg')} {
            column-gap: 30px;
        }
        
        ${theme.breakpoints.only('md')} {
            display: flex;
            column-gap: 50px;
            row-gap: 30px;
            flex-wrap: wrap;
            justify-content: center;
        }

        ${theme.breakpoints.down('sm')} {
            display: flex;
            flex-direction: column;
        }

        ${theme.breakpoints.only('sm')} {
            row-gap: 49px;
        }

        ${theme.breakpoints.down('xs')} {
            row-gap: 28px;
        }
    `;

    const linkStyle = css`
        height: auto;
    `;

    const cardStyle = css`
        flex-shrink: 0;

        .text-container {
            padding-top: 0;
        }

        .header {
            font-size: 19px;
            line-height: 23px;
            margin-bottom: 0;
        }

        .description {
            font-size: 14px;
            line-height: 18px;
        }

        ${theme.breakpoints.up('xl')} {
            width: 326px;
            height: 290px;
        }

        ${theme.breakpoints.down('lg')} {
            width: 290px;
            height: 280px;
        }

        ${theme.breakpoints.down('xs')} {
            .header {
                font-size: 16px;
                line-height: 23px;
            }
        }
    `;

    if (!relatedEvents.length) {
        return null;
    }

    return (
        <div css={style}>
            <div css={relatedTitleStyle}>You may also like...</div>
            <div css={cardsContainerStyle}>
                {relatedEvents.map((eventPage: EventPage) => (
                    <LinkTo
                        key={eventPage.id}
                        to={urlSegments + '/' + eventPage.uRLSegment}
                        css={linkStyle}
                    >
                        <RelatedEventPage
                            event={eventPage}
                            css={cardStyle}
                        />
                    </LinkTo>
                ))}
            </div>
        </div>
    );
}

export default RelatedEvents;